const adminRoutes = [
  {
    path: "/login",
    name: "admin-login",
    component: () => import("../views/admin/setting/Login.vue"),
    meta: {
      title: "登录"
    }
  },
  {
    path: "/",
    name: "admin",
    component: () => import("../views/admin/Base.vue"),
    redirect: "/article/list",
    children: [
      {
        path: "/article/list",
        component: () => import("../views/admin/article/List.vue"),
        meta: {
          key: ["article"],
          sub: ["article"],
          permission: "article",
          title: ["案例集管理", "案例列表"]
        }
      },
      {
        path: "/article/category",
        component: () => import("../views/admin/article/Category.vue"),
        meta: {
          key: ["article-category"],
          sub: ["article"],
          permission: "article",
          title: ["案例集管理", "一级分类"]
        }
      },
      {
        path: "/article/subcategory",
        component: () => import("../views/admin/article/SubCategory.vue"),
        meta: {
          key: ["article-subcategory"],
          sub: ["article"],
          permission: "article",
          title: ["案例集管理", "二级分类"]
        }
      },
      {
        path: "/article/banner",
        component: () => import("../views/admin/article/Banner.vue"),
        meta: {
          key: ["article-banner"],
          sub: ["article"],
          permission: "article",
          title: ["案例集管理", "banner列表"]
        }
      },
      {
        path: "/article/contact",
        component: () => import("../views/admin/article/Contact.vue"),
        meta: {
          key: ["article-contact"],
          sub: ["article"],
          permission: "article",
          title: ["案例集管理", "联系我们"]
        }
      },
      // 七牛管理 文件列表
      {
        path: "/qiniu/list",
        component: () => import("../views/admin/qiniu/List.vue"),
        meta: {
          key: ["qiniu-list"],
          sub: ["qiniu"],
          permission: "qiniu",
          title: ["七牛管理", "上传记录"]
        }
      },
      // 后台管理 管理组列表
      {
        path: "/user/permission",
        component: () => import("../views/admin/setting/UserPermission.vue"),
        meta: {
          key: ["admin-group"],
          sub: ["admin"],
          permission: "admin",
          title: ["后台管理", "管理组列表"]
        }
      },
      // 后台管理 管理人员列表
      {
        path: "/user/list",
        component: () => import("../views/admin/setting/UserList.vue"),
        meta: {
          key: ["admin-manager"],
          sub: ["admin"],
          permission: "admin",
          title: ["后台管理", "管理员列表"]
        }
      },
      // 无权限  404
      {
        path: "/permission/404",
        component: () => import("../views/admin/setting/Permission404.vue"),
        meta: {
          key: ["not found"],
          sub: ["not found"],
          permission: "not found",
          title: ["您没有权限访问该链接，请联系管理员开通"]
        }
      }
    ]
  }
];

export default adminRoutes;
